import type { ReactNode } from 'react';
import { NotificationsBell } from './NotificationsBell';
import { UserMenu } from './UserMenu';
import { Group, Text } from '@mantine/core';




type Props = {
  children?: ReactNode;
};

export function HeaderLayout({ children }: Readonly<Props>) {
  return (
    <Group
      bg={'var(--bg-surface)'}
      component="header"
      px={24}
      h={60}
      style={{ borderBottom: "1px solid var(--border-default)", zIndex: 2 }}
      flex={'none'}
      justify='space-between'
    >

      <Group gap={28} align="center" wrap="nowrap">
        <Group gap={10} align="center" wrap="nowrap">
          <img
            src="/cloudhouse-logo.png"
            alt="Cloudhouse"
            width={138}
            style={{ height: 'auto' }}
          />
          <Text fw={800} fz={'lg'} lts={'-0.3px'} lh={'normal'}>Hub</Text>
        </Group>

      </Group>
      {children}

      <Group gap={12} align="center" wrap="nowrap">
        <NotificationsBell />
        <UserMenu />
      </Group>
    </Group>
  );
}

